import { render, staticRenderFns } from "./JianchaFabu.vue?vue&type=template&id=50373a1a&"
import script from "./JianchaFabu.vue?vue&type=script&lang=js&"
export * from "./JianchaFabu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "JianchaFabu.vue"
export default component.exports